// To mock a new tenant, add an entry to `tenantOverrides` with only the fields
// that should differ from SHY.

const baseTenant = {
    tenantId: "",
    tenantDomain: "",
    tenantDomainMU: "",
    tenantFrontendWebsiteAddress: "",
    tenantPhoneNumber: "",
    tenantEmailAddress: "",
    heroImage: "",
    isLandingPageBlackText: false,
    logoImage: "/icons/shy-logo.png",
    favIcon: "/favicon.ico",
    appleTouchIcon: "/apple-touch-icon.png",
    showPoweredByLogo: false,
    showChat: false,
    showContactLinkInQuoteDashboard: false,
    logoWidth: "",
    logoHeight: "",
    isDarkHeader: false,
    isDarkQuoteModalHeader: false,
    isDarkButton: false,
    metaTitlePBS: "",
    metaDescriptionPBS: "",
    tenantName: "SHY Aviation",
};

// Returned alongside the FRLG tenant by the real API. Kept with the override
// rather than in the base: these values assume a light, tenant-branded quote
// page, so applying them to an unthemed tenant would fight the SHY styles.
const frlgThemeDefaults = {
    loadingBigHeight: "65px",
    loadingBigWidth: "65px",
    loadingHeight: "50px",
    loadingWidth: "50px",
    quoteBg: "#ffffff",
    quoteHeaderBg: "#ffffff",
    quoteHeaderColor: "#000000",
    quoteQueryPaddingTop: "20px",
    quoteNoResultsColor: "#000000",
    aircraftCardBg: "#fffffe",
    aircraftCardExtraActionsBg: "#e5e5e5",
    checkboxSuccessBg: "#000000",
    footerColor: "#ffffff",
    navOverlayOpacity: "0.2",
};

const baseTheme = {
    // `body.is-powered-by` re-points --journey-leg-table-border (and the quote
    // ref / trip type / small print that follow it) at --button-border, whose
    // :root default is `transparent` because SHY itself is never powered-by.
    // Restoring SHY's white keeps an unthemed tenant legible.
    buttonBorder: "#ffffff",
};
const baseThemeDefaults = {};

const tenantOverrides = {
    FRLG: {
        themeDefaults: frlgThemeDefaults,
        tenant: {
            tenantId: "FRLG",
            tenantDomain: "dev.firstluxegroup-privatejet.com",
            tenantDomainMU: "FRLG",
            tenantFrontendWebsiteAddress: "https://dev.firstluxegroup-privatejet.com",
            tenantPhoneNumber: "+44 (0)20 7481 6810",
            tenantEmailAddress: "fly@firstluxegroup-privatejet.com",
            heroImage:
                "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/e3ui21by/herof37ad908722e8cb1cc0e.jpg",
            isLandingPageBlackText: false,
            logoImage:
                "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/wwbdyxog/firstluxe-logo.png",
            favIcon:
                "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/lxofywzt/firstluxe-favicon.png",
            appleTouchIcon:
                "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/lxofywzt/firstluxe-favicon.png",
            showPoweredByLogo: false,
            showChat: false,
            showContactLinkInQuoteDashboard: false,
            logoWidth: "78",
            logoHeight: "78",
            instagram: "https://www.instagram.com/firstluxegroup/",
            linkedin: "https://www.linkedin.com/company/firstluxe-serviced-ltd/about/",
            isDarkHeader: false,
            isDarkQuoteModalHeader: false,
            isDarkButton: false,
            metaTitlePBS: "FirstLuxe | Private Jet Broker",
            metaDescriptionPBS:
                "We are a global private aviation charter service with access to the finest aircraft on the market.",
            tenantName: "FirstLuxe",
        },
        theme: {
            quoteQueryTabColor: "#ff00aa",
            quoteQueryScrolledBg: "#000000",
            quoteQueryScrolledColor: "#93c47d",
            homeQueryTitleColor: "#ffffff",
            homeQuerySubTitleColor: "#ffffff",
            homeQueryAreYouLookingForColor: "#ffffff",
            quoteQueryPersonalDetailsHeaderBg: "#000000",
            quoteQueryPersonalDetailsHeaderColor: "#3d85c6",
            journeyLegDotBg: "#bcbcbc",
            quoteQueryDeleteButtonColor: "#6fa8dc",
            quoteQueryDeleteButtonAltColor: "#ffffff",
            quoteQueryAddButtonColor: "#ffffff",
            quoteQueryAddButtonAltColor: "#ffffff",
            journeyLegTableBg: "#123456",
            journeyLegTableColor: "#fedcba",
            journeyLegIconColor: "#990000",
            aircraftBrowserFiltersColor: "#000000",
            aircraftBrowserFiltersActiveColor: "#000000",
            aircraftBrowserResultsColor: "#ffffff",
            aircraftBrowserResultsTitleColor: "#ffffff",
            aircraftBrowserResultsListColor: "#ffffff",
            blockHeaderH1Color: "#000000",
            blockHeaderH1ColorLight: "#ffffff",
            blockHeaderH1ColorLightAlt: "#ffffff",
            blockHeaderH2Color: "#999999",
            blockTextBg: "#1d1d1b",
            blockFaqsBg: "#1d1d1b",
            blockReadMoreButtonColor: "#ffffff",
            foldIndicatorIcon: "#ffffff",
            headerBg: "#000000",
            headerBgScrolled: "#000000",
            headerColor: "#ffffff",
            bodyBg: "#ffffff",
            exampleBorderColour: "#f6b26b",
            loadingIcon: "#ffd966",
            quoteCtaBarBg: "#8fce00",
            quoteCtaBarDivideBg: "#660000",
            quoteQueryExpandIcon: "#bf9000",
            rcSliderHandleBg: "#999999",
            rcSliderRailBg: "#ffffff",
            buttonBg: "#741b47",
            buttonColor: "#ffffff",
            buttonBorder: "#cc0000",
            footerBg: "#000000",
            footerHoverIcon: "#999999",
            footerHoverColor: "#ffffff",
            brochureH1: "#ffffff",
            brochureH2: "#ffffff",
            brochureTextColor: "#ffffff",
            swiperPaginationBulletBg: "#ffffff",
            swiperPaginationBulletActiveBg: "#ffffff",
            swiperButtonColor: "#000000",
            swiperButtonBg: "#ffffff",
            swiperPaginationColor: "#ffffff",
            swiperPaginationBg: "#ffffff",
            blogArticlePreviewCtaColor: "#000000",
            brochurePanelBg: "#000000",
            brochurePanelBorder: "#ffffff",
            brochurePanelIcon: "#ffffff",
            brochurePanelTitleColor: "#ffffff",
            brochurePanelBodyColor: "#ffffff",
            headerEmail: "#000000",
            footerEmail: "#000000",
            footerTextEmail: "#ffffff",
            buttonEmail: "#000000",
            buttonTextEmail: "#ffffff",
            linkTextEmail: "#999999",
            homeServiceBg: "#000000",
            homeServiceTitleColor: "#ffffff",
            homeServiceBodyColor: "#ffffff",
            homeServiceCtaColor: "#ffffff",
            testimonialsAuthorColor: "#ffffff",
            navBg: "#000000",
            navColor: "#ffffff",
            navSecondaryColor: "#ffffff",
            navHoverColor: "#999999",
            buttonNavBg: "#000000",
            buttonNavIcon: "#ffffff",
            buttonNavBorder: "#ffffff",
            buttonNavColor: "#ffffff",
            buttonNavHoverBorder: "#999999",
            buttonNavHoverColor: "#999999",
        },
    },
};

export const getTenantById = (tenantId) => {
    const override = tenantOverrides[tenantId] || {};

    return {
        tenant: {
            ...baseTenant,
            ...(override.tenant || {}),
            tenantId: tenantId || "",
        },
        themeDefaults: { ...baseThemeDefaults, ...(override.themeDefaults || {}) },
        theme: { ...baseTheme, ...(override.theme || {}) },
    };
};

export { baseTenant, baseTheme, baseThemeDefaults, tenantOverrides };
